import { array, number, boolean, defineAction, object, string, enumerated } from '~/prix'
import legalEntityMassGeocodeAction from './legalEntityMassGeocode.action.json'

const legalEntityMassGeocodeDefinition = defineAction({
  ...legalEntityMassGeocodeAction,
  input: object({
    concurrency: number().label('Quantidade de cidades a se processar de forma concorrente.'),
    addressConcurrency: number()
      .isOptional()
      .label('Quantidade de endereços geocodificados simultaneamente por cidade.'),
    level: enumerated({
      macroRegion: 'macroRegion',
      mesoRegion: 'mesoRegion',
      microRegion: 'microRegion',
      state: 'state',
      city: 'city',
    }).isOptional(),
    ibgeCodes: string(),
    force: boolean()
      .isOptional()
      .label(
        'Geocodificar todos os endereços na legal_entity e não somente os nulos ou desatualizados.',
      ),
    ensureGeocodingVersion: boolean()
      .isOptional()
      .label('Geocodificar onde a versão do geocoding for diferente da mais atual.'),
    applyParaibaSpatialSafety: boolean()
      .isOptional()
      .label('Aplicar a guarda espacial validada somente para o canário da Paraíba.'),
    rejectedOnly: boolean()
      .isOptional()
      .label('Reprocessar somente rejeições espaciais ainda pendentes, sem agendar exportação.'),
    debug: boolean().isOptional(),
    geocodeWhere: string().isOptional(),
    uniqueKey: string().isOptional(),
    chunkSize: string().isOptional(),
  }),
  output: object({}),
})

export default legalEntityMassGeocodeDefinition
